// LeaveTable.jsx
import { Calendar, Pencil, Trash } from 'lucide-react';

function calculateLeaveDays(start, end) {
  const s = new Date(start);
  const e = new Date(end);
  return Math.max(1, Math.round((e - s) / (1000 * 60 * 60 * 24)) + 1);
}

export default function LeaveTable({ leaves }) {
  return (
    <div className="backdrop-blur-sm bg-white/80 rounded-2xl shadow-xl overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gradient-to-r from-gray-50 to-white border-b border-gray-200">
          <tr>
            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee</th>
            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dates</th>
            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-4"></th>
          </tr>
        </thead>
        <tbody>
          {leaves.map((leave, index) => {
            const formattedStart = new Date(leave.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
            const formattedEnd = new Date(leave.endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
            return (
              <tr
                key={leave.id}
                className={`border-b border-gray-100 transition-colors hover:bg-gray-50/50 ${
                  index % 2 === 0 ? 'bg-white/50' : 'bg-gray-50/30'
                } group`}
              >
                <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{leave.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-700">{leave.leaveType}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <Calendar className="h-4 w-4 text-gray-400 mr-2" />
                    <span>{formattedStart} - {formattedEnd}</span>
                    <span className="mx-2 text-gray-300">•</span>
                    <span className="text-sm text-gray-500">{calculateLeaveDays(leave.startDate, leave.endDate)} days</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    leave.status === 'pending'
                      ? 'bg-amber-100 text-amber-800 animate-pulse'
                      : leave.status === 'approved'
                        ? 'bg-emerald-100 text-emerald-800'
                        : 'bg-rose-100 text-rose-800'
                  }`}>
                    {leave.status.charAt(0).toUpperCase() + leave.status.slice(1)}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right">
                  <div className="flex opacity-0 group-hover:opacity-100 transition-opacity">
                    <button className="p-1.5 text-gray-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg">
                    <Pencil className="h-4 w-4" />
                    </button>
                    <button className="p-1.5 text-gray-500 hover:text-rose-600 hover:bg-rose-50 rounded-lg">
                    <Trash className="h-4 w-4" />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
